import { toast } from "react-hot-toast";
import { confirmAlert } from "react-confirm-alert";

import { API_SUCCESS } from "api/ResponseCodes";
import { BASE_URL_FILE_UPLOAD, BASE_URL_MULTI_PART_FILE_UPLOAD, Download_File_GET, Upload_File_POST } from "api/ApiConst";
import { callDeleteApi, callPostApi, callPutApi } from "api/ApiCaller";
import { isEmpty } from "./TextUtils";
import { SECTION_LOADER } from "./constants";

export const getRoleTypeString = (roleType) => {
    if (isEmpty(roleType)) {
        return "";
    }
    if (roleType === "ROLE_SUPER_ADMIN") {
        return "Super Admin";
    }
    if (roleType === "ROLE_ADMIN") {
        return "Admin";
    }
    return roleType;
};

//Action Active
export const handleActive = (url, refreshTable) => {
    callPutApi(SECTION_LOADER, url, {}, {}, (response) => {
        if (response.errorCode === API_SUCCESS) {
            toast.success(response.message);
            refreshTable();
        } else {
            toast.error(response.message);
        }
    });
};

//  Action Inactive
export const handleInactive = (url, refreshTable) => {
    callPutApi(SECTION_LOADER, url, {}, {}, (response) => {
        if (response.errorCode === API_SUCCESS) {
            toast.success(response.message);
            refreshTable();
        } else {
            toast.error(response.message);
        }
    });
};

//   Action Delete
export const handleDelete = (url, refreshTable) => {
    confirmAlert({
        title: "Delete ?",
        message: "Do you want to delete this record ?",
        icon: "warning",
        buttons: [
            {
                label: "Yes",
                onClick: () => {
                    callDeleteApi(SECTION_LOADER, url, {}, (response) => {
                        if (response.errorCode === API_SUCCESS) {
                            toast.success(response.message);
                            refreshTable();
                        } else {
                            toast.error(response.message);
                        }
                    });
                },
            },
            {
                label: "No",
            },
        ],
    });
};

// Action Revive
export const handleRevive = (url, refreshTable) => {
    callPutApi(SECTION_LOADER, url, {}, {}, (response) => {
        if (response.errorCode === API_SUCCESS) {
            toast.success(response.message);
            refreshTable();
        } else {
            toast.error(response.message);
        }
    });
};

export const userNameImageObject = (userData) => {
    return {
        fullName: userData.firstName + " " + userData.lastName,
        imageUrl: userData.photoImageUrl,
    };
};

// export const callImageUploader = async (base64, fileName) => {
//     console.log(base64)
//     console.log(fileName)
//     const res = await fetch(base64);
//     const blob = await res.blob();
//     let formData = new FormData();
//     formData.append("file", blob, fileName);
//     return callImageUploaderApi(formData);
// };
export const callImageUploader = async (base64, fileName) => {
    return callImageUploaderApi(base64, fileName);
};

export const callVideoUploader = async (fileName) => {
    return callVideoUploaderApi(fileName);
};

// const callImageUploaderApi = async (formData) => {
//     console.log("FormData: ", formData);
//     return new Promise((resolve, reject) => {
//         callPostApi(
//             null,
//             BASE_URL_FILE_UPLOAD,
//             formData,
//             {},
//             (response) => {
//                 if (response.errorCode === API_SUCCESS) {
//                     resolve(response.responsePacket);
//                     return response.responsePacket;
//                 } else {
//                     reject(null);
//                     toast.error(response.message);
//                                     }
//             },
//             (error) => {
//                 reject(null);
//                 toast.error(error);
//                 return null;
//             }
//         );
//     });
// };
const callImageUploaderApi = async (base64, fileName, type) => {
    const imgObj = {
        fileName: fileName,
        fileBase64: base64,
    };
    return new Promise((resolve, reject) => {
        callPostApi( null, BASE_URL_FILE_UPLOAD, imgObj, {}, (response) => {
                if (response.errorCode === API_SUCCESS) {
                    resolve(response.responsePacket);
                    return response.responsePacket;
                } else {
                    reject(null);
                    // toast.error(response.message);
                    // console.log('first')
                    // throw new Error('Something went wrong');
                }
            },
            (error) => {
                reject(null);
                toast.error(error);
                // throw new Error('Something went wrong');
            }
        );
    });
};
const callVideoUploaderApi = async (fileName) => {
    // const imgObj = {
    //     file: fileName,
    // };
    const formdata = new FormData();
    formdata.append('file', fileName);
    return new Promise((resolve, reject) => {
        callPostApi( null, BASE_URL_MULTI_PART_FILE_UPLOAD, formdata, {}, (response) => {
                if (response.errorCode === API_SUCCESS) {
                    resolve(response.responsePacket);
                    return response.responsePacket;
                } else {
                    reject(null);
                    // toast.error(response.message);
                    // console.log('first')
                    // throw new Error('Something went wrong');
                }
            },
            (error) => {
                reject(null);
                toast.error(error);
                // throw new Error('Something went wrong');
            }
        );
    });
};

// export const getImageSrcViaRefId = (refId) => {
//     if (refId) {
//         return Download_File_GET.replaceAll("{attachemntId}", refId);
//     }
//     // return "/assets/images/users/defaultUser.png"
// };

export const getImageSrcViaRefId = (refId) => {
    if (refId) {
        return refId;
    }
};
export const getVideoSrcViaRefId = (refId) => {
    if (refId) {
        return refId;
    }
}
